/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect, FC, useRef, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
import { Icon, useBreakpoint, useDidMount } from '@mtsbank/ui-kit';
import { checkIsServiceNonTopUp, checkIsWithPercentFee, PaymentPayee, useCyberStore } from '@entities/tsp';
import { Partners, usePartner } from '@shared/lib/partner';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import { getClientFeeAmount } from '../lib/getClientFeeAmount';
interface IProps {
  showVouchersForm: boolean;
  payee: PaymentPayee;
}
const StickyPaymentInfo: FC<PropsWithChildren<IProps>> = ({
  showVouchersForm,
  payee,
  children
}) => {
  const {
    isMobile
  } = useBreakpoint();
  const {
    amountInfo,
    isPromocodeActivated,
    paymentMethod
  } = useCyberStore();
  const [isSticky, setSticky] = useState(false);
  const {
    partner
  } = usePartner();
  const rulesFaqButtonRef = useRef<HTMLButtonElement>(null);
  const isPubg = payee.features?.tsp_url === 'pubg-mobile';
  const isNonTopUpService = checkIsServiceNonTopUp(showVouchersForm, payee);
  const isTopUpWithPercentFeeService = checkIsWithPercentFee(payee);
  const feeAmount = getClientFeeAmount(amountInfo, isPubg, isNonTopUpService, isTopUpWithPercentFeeService, paymentMethod);
  const onSiteRulesClick = () => {
    if (rulesFaqButtonRef.current) {
      rulesFaqButtonRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      if (rulesFaqButtonRef.current.nextElementSibling?.getAttribute('aria-hidden') === 'true') {
        rulesFaqButtonRef.current.click();
      }
    }
  };
  const handleScroll = () => {
    const payElement = document.getElementById('pay');
    if (!payElement) return;
    const payElementTop = payElement.getBoundingClientRect().top + 72;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    if (payElementTop <= windowHeight) {
      setSticky(false);
    } else {
      setSticky(true);
    }
  };
  useDidMount(() => {
    handleScroll();
  });
  useEffect(() => {
    const allFaqAccordionButtons = document.querySelectorAll('[class*="AccordionButton"]');
    const rulesFaqButton = allFaqAccordionButtons[allFaqAccordionButtons.length - 1] as HTMLButtonElement;

    // @ts-ignore
    rulesFaqButtonRef.current = rulesFaqButton;
  }, []);
  useEffect(() => {
    if (isMobile) {
      window.addEventListener('scroll', handleScroll);
    } else {
      setSticky(false);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);
  const isSteam = payee.features?.tsp_url === 'steam';
  if (!isSticky) {
    return null;
  }
  return <WrapperStickyButton id="sticky-component">
      <Info>
        <div>Комиссия {isPromocodeActivated && isSteam ? 0 : feeAmount} ₽</div>
        <InfoTitle>
          <span>Оплата по «Системе быстрых платежей»</span>
          <IconWrapper>
            <Icon width={13} height={16} icon="payment/sbp" />
          </IconWrapper>
        </InfoTitle>
      </Info>
      <Spacer space={10} spacetablet={10} spacemob={10} />
      {children}
      {partner === Partners.DEFAULT && <>
          <Spacer space={16} spacemob={16} />
          <DefaultWrapperText>
            Нажимая кнопку «Оплатить», вы&nbsp;соглашаетесь с&nbsp;
            <ButtonText onClick={onSiteRulesClick}>правилами использования сайта</ButtonText>
          </DefaultWrapperText>
        </>}
    </WrapperStickyButton>;
};
export default StickyPaymentInfo;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const WrapperStickyButton = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperStickyButton",
  class: "wduk9vw",
  propsAsIs: false,
  vars: {
    "wduk9vw-0": [_exp()]
  }
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const Info = withTheme(/*#__PURE__*/styled('div')({
  name: "Info",
  class: "i1dp8ehx",
  propsAsIs: false,
  vars: {
    "i1dp8ehx-0": [_exp2()],
    "i1dp8ehx-1": [_exp3(), "px"],
    "i1dp8ehx-2": [_exp4()],
    "i1dp8ehx-3": [_exp5(), "px"],
    "i1dp8ehx-4": [_exp6()]
  }
}));
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const InfoTitle = withTheme(/*#__PURE__*/styled('div')({
  name: "InfoTitle",
  class: "ih1uuj6",
  propsAsIs: false,
  vars: {
    "ih1uuj6-0": [_exp7()]
  }
}));
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "ixsldp6",
  propsAsIs: false
});
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxxs;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxxs;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const DefaultWrapperText = withTheme(/*#__PURE__*/styled('div')({
  name: "DefaultWrapperText",
  class: "d4zlrgp",
  propsAsIs: false,
  vars: {
    "d4zlrgp-0": [_exp8()],
    "d4zlrgp-1": [_exp9()],
    "d4zlrgp-2": [_exp0(), "px"],
    "d4zlrgp-3": [_exp1(), "px"],
    "d4zlrgp-4": [_exp10()]
  }
}));
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primaryLink;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.primaryLinkHover;
const ButtonText = withTheme(/*#__PURE__*/styled('p')({
  name: "ButtonText",
  class: "bp8w678",
  propsAsIs: false,
  vars: {
    "bp8w678-0": [_exp11()],
    "bp8w678-1": [_exp12()]
  }
}));

require("./StickyPaymentInfo.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./StickyPaymentInfo.tsx");